
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    totalItemsPago: 0,
    
});






export const useItemspagoStore = create()(
    devtools(
        storeApi
    )
)
